

var Carousel = {
  init(){
    this.list = $('.fnc-carousel');
    this.child = this.list.children();
    this.winWidth = $(window).width();
    this.imgHeight = this.list.find('img').eq(0).height();



    this.setSlick();
    this.event();

    TweenMax.to(this.list , 0.5 , {
      opacity : 1, 
      delay : 1, 
    　ease : "Linear" ,
      onComplete : ()=>{
      },
      onStart  : ()=>{} ,
      onUpdate : ()=>{} 
    });
  },
  event(){
    $(window).on('resize.slick', ()=>{
      this.winCheck();
      this.reSlick();
    });
  },
  setSlick(){
    if( window.matchMedia('(min-width: 768px)').matches ){
      this.list.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false
      });
    }else{
      // console.log(this.list.width()* 0.49);
      // this.child.each((i, obj)=>{
      //   $(obj).find('a').eq(0).css({
      //     width: this.list.width() * 0.5
      //   })
      // });
      this.list.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false
      });
    }
  },
  reSlick(){
    this.list.slick('unslick');
    this.setSlick();
  },
  winCheck(){
    this.winWidth = $(window).width();
  }
}

module.exports = Carousel;


// WEBPACK FOOTER //
// ./src/js/fncs/Carousel.js